"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var react_focus_lock_1 = (0, tslib_1.__importDefault)(require("react-focus-lock"));
var accessibility_focus_1 = (0, tslib_1.__importDefault)(require("../../../utils/accessibility-focus"));
var overlay_focus_lock_scss_1 = (0, tslib_1.__importDefault)(require("./overlay-focus-lock.scss"));
var withStyles_1 = require("../../../../common/utils/withStyles");
var OverlayFocusLock = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(OverlayFocusLock, _super);
    function OverlayFocusLock(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickOutside = function (event) {
            var eventTarget = event.target;
            if (_this.ref && !_this.ref.contains(eventTarget)) {
                _this.disableFocusLock(function () {
                    (0, accessibility_focus_1.default)(eventTarget);
                });
            }
        };
        _this.saveRef = function (ref) { return (_this.ref = ref); };
        _this.lastFocusedElement = null;
        _this.state = {
            isFocusLockEnabled: false,
        };
        return _this;
    }
    OverlayFocusLock.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var isEnabled = this.props.isEnabled;
        if (isEnabled && !prevProps.isEnabled) {
            // enable focus lock with slight delay to allow it catch focusable elements
            this.lastFocusedElement = document.activeElement;
            setTimeout(function () { return _this.enableFocusLock(); }, 200);
        }
        if (!isEnabled && prevProps.isEnabled) {
            this.disableFocusLock();
        }
    };
    OverlayFocusLock.prototype.enableFocusLock = function () {
        this.setState({ isFocusLockEnabled: true });
        document.addEventListener('mousedown', this.handleClickOutside, true);
    };
    OverlayFocusLock.prototype.disableFocusLock = function (callback) {
        this.setState({ isFocusLockEnabled: false }, callback);
        document.removeEventListener('mousedown', this.handleClickOutside, true);
        (0, accessibility_focus_1.default)(this.lastFocusedElement);
    };
    OverlayFocusLock.prototype.render = function () {
        var children = this.props.children;
        var isFocusLockEnabled = this.state.isFocusLockEnabled;
        return (react_1.default.createElement("div", { ref: this.saveRef, className: overlay_focus_lock_scss_1.default.container },
            react_1.default.createElement(react_focus_lock_1.default, { disabled: !isFocusLockEnabled }, children)));
    };
    OverlayFocusLock = (0, tslib_1.__decorate)([
        (0, withStyles_1.withStyles)(overlay_focus_lock_scss_1.default)
    ], OverlayFocusLock);
    return OverlayFocusLock;
}(react_1.default.Component));
exports.default = OverlayFocusLock;
//# sourceMappingURL=overlay-focus-lock.js.map